import { CardPaymentRedirectState } from './../reducers/card.payment.redirect.reducer';
import { COMPLETE_ORDER_FEATURE } from './../reducers/index';
import { createSelector, createFeatureSelector } from '@ngrx/store';
import * as fromCompleteOrder from '@complete-order/store/reducers';

const getCompleteOrderState =
  createFeatureSelector<fromCompleteOrder.CompleteOrderState>(
    COMPLETE_ORDER_FEATURE
  );

export const getCardPaymentRedirectState = createSelector(
  getCompleteOrderState,
  (state) => state?.cardPaymentRedirect
);

export const getCardPaymentRedirect = createSelector(
  getCardPaymentRedirectState,
  (state: CardPaymentRedirectState) => state?.data
);

export const getCardPaymentRedirectLoading = createSelector(
  getCardPaymentRedirectState,
  (state: CardPaymentRedirectState) => state?.loading
);

export const getCardPaymentRedirectLoaded = createSelector(
  getCardPaymentRedirectState,
  (state: CardPaymentRedirectState) => state?.loaded
);

export const getCardPaymentRedirectError = createSelector(
  getCardPaymentRedirectState,
  (state: CardPaymentRedirectState) => state?.error
);
